import React, { useState, useEffect, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import 'react-times/css/classic/default.css';
import Images from 'assets/images/imageData';
import "./assesment.css";
import { is } from 'date-fns/locale';

const styles = {
    fontFamily: "sans-serif",
    width: "500px",
  
    border: "1px solid #eee",
    background: "#f3f3f3",
    padding: "25px",
    margin: "20px"
  };
  

const AssesmentResources = ({
    match,
    history,
    getResources,
    resources
}) => { 
    const { id } = useParams();
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [roleId, setRoleId] = useState('');
    const [levelId, setLevelId] = useState('');
    const [resourcesData, setResourceData] = useState([]);
    const [searchKey,setSearchKey] = useState(null);

    useEffect(() => {
        if(match.params.id !== undefined) {
            setLevelId(match.params.id);
        }
        if(match.params.role_id !== undefined) {
            setRoleId(match.params.role_id); 
        }

    },[match.params.id,match.params.role_id]);

    useEffect(() => {
        if(getResources !== undefined && roleId && levelId) {
         (async () => {
           setIsLoading(true);
           const res = await getResources(levelId,roleId,null);
           if(res) {
             console.log(res);
           }
           setIsLoading(false);
         })();  
        }
     },[getResources,roleId,levelId]);

     useEffect(() => {
        if(resources) {
            setResourceData(resources);
        }
     },[resources]);

     const handleInputChange = (e) =>{
      setSearchKey(e.target.value);
    } 

    const applySearchKey = async () => {
      console.log(searchKey)
      setIsLoading(true);
      const res = await getResources(levelId,roleId,searchKey);
      if(res) {
        console.log(res);
      }
      setIsLoading(false);
    };

  const headerBtn = () => {
      return (
        <div className="border border-primary rounded-10  searchBox" >
        <div className="input-group">
              <input type="search" className="form-control rounded borderColorBox" onChange={e => handleInputChange(e)} placeholder="Search File..." aria-label="Search" aria-describedby="search-addon" />
              <button type="button" className="btn-custom" onClick={applySearchKey}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
              </svg>
              </button>
            </div>
        </div>
      )
  }
    return(
        <Layout
            title={localization.assesmenResources}
            isGoback={true}
            isLoading={isLoading}
            linkUrl={`${baseUrl}/training-levels`}
            Buttons={headerBtn}
        >
        <div className="container-fluid">
         <div className="card">
          <div className='card-header'>Resources</div>
          <div className="card-body">
            {resourcesData && resourcesData.length > 0 ? 
              (
               <>
                {resourcesData.map((value,index) => {
                  return (
                  <div className='col-md-4 card-x-padding'>
                    <div className="card">
                    <div className="card-body">
                    <a target="_blank" href={value.file_path}>
                    <img src={value.file_type == 'Video' ? Images?.AssesmentVideoIcon : Images?.AssesmentFileIcon} height="50" />
                    <span>
                      {/* {value.file_type == 'Video' ? 'Source Video' : 'Source File'} */}
                    {value?.file_name}
                    </span>
                    <span>
                        <button className='btn btn-sm btn-success assesment-video'>
                        {value.file_type == 'Video' ? 'Play' : 'View'}
                        </button>
                    </span>
                    </a>
                    </div>
                    </div>
                  </div>
                  )
                })}
               </>
              ): <div><img src={Images?.NoData} alt="" width="100%" /></div>}
          </div>
          {/* <div style={{'margin':'20px 20px 20px 20px','text-align':'center'}} className="col-md-12 col-sm-5">
            <button className="btn btn-sm btn-success" onClick={() => handleTestStart(false)}>Start Test</button>
          </div> */}
         </div>
        </div> 
        </Layout>
    );

};
export default AssesmentResources;